import { styled } from '@material-ui/core';
import CreationBody from './CreationBody';
import useMediaQuery from '@mui/material/useMediaQuery';

const MainBody = styled('div')(({ theme }) => ({
  width: '100%',
  height: '90vh',
  maxWidth: '425px',
  overflowY: 'auto',
  margin: '130px auto 50px auto',
  boxShadow: theme.shadows[10],
  borderRadius: '20px',
}));

const Body = (props: any) => {
  const matches = useMediaQuery('(min-width:600px)');
  return (
    <MainBody
      className="scrollbar-hidden"
      style={{ padding: matches ? '30px' : '0px' }}
    >
      <CreationBody />
    </MainBody>
  );
};

export default Body;
